import React from 'react';
import { recognizeItems } from '../data/content';
import { Icon } from '../utils/icons';
export function Recognize() {
  return <section className="w-full bg-sand px-5 py-20 sm:py-24" data-id="element-166" data-mp="30yj6lyj4ug50">
      <div className="mx-auto max-w-4xl" data-id="element-167" data-mp="2w5yc0usejz0f">
        <div className="text-center" data-id="element-168" data-mp="2w4x1qsj7ngjr">
          <h2 className="font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-169" data-mp="2r7eoipy5uf5y">
            Do You Recognize Yourself in These Situations?
          </h2>
          <p className="mt-3 text-sm text-ink/55" data-id="element-170" data-mp="2i6qavwcoigtl">
            If you said yes to any of these — this pack is for you.
          </p>
        </div>

        <ul className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-171" data-mp="2d8ouxkajuxmc">
          {recognizeItems.map(item => <li key={item.text} className="flex items-start gap-3 rounded-xl bg-white px-4 py-4" data-id="element-172" data-mp="28a3rlc003xto">
              <Icon name={item.icon} className="h-4 w-4 shrink-0 text-brand" data-id="element-173" data-mp="6h631sd9brej" />
              <span className="text-xs font-medium leading-snug text-ink/80" data-id="element-174" data-mp="6f32wfie4hw3">
                {item.text}
              </span>
            </li>)}
        </ul>

        <p className="mt-10 text-center font-display text-lg font-bold italic text-brand sm:text-xl" data-id="element-175" data-mp="3nngojnc7u1hy">
          And you deserve so much more than that →
        </p>
      </div>
    </section>;
}